<template>
    <div class="fzg-about-mobile">
      <div class="fzg-banner">
        <fzg-menu/>
        <img class="banner-bg" src="../../assets/img2/mobile/about/banner.jpg" alt="">
        <img class="banner-intro" src="../../assets/img2/mobile/about/intro.jpg" alt="">
      </div>

      <div class="section fzg-about-intro">
        <template v-if="false">
          <img class="eco-title" src="../../assets/img2/pc/about/fzg-about-title-intro.png" alt="">
          <div class="intro-title-line"></div>
          <div class="intro-content">
            <div class="left">
              <img class="logo" src="../../assets/img2/pc/about/fzg-about-logo.jpg">
            </div>
            <div class="right">
              <p>凡卓集团成立于2014年，依托独有的创投生态体系，扎根产业实体。面向高质量的科创城市、创业者、机构投资者、产业专家、行业从业者、科创巨头企业，提供财务顾问、直接投资、创业孵化、创投媒体、产业咨询、商机对接、创投培训、路演论坛、飞地运营等服务。 </p>
              <br>
              <p>凡卓集团的使命是“帮助创业者找人、找钱、找产业政策”，旗下包含小饭桌创服、小饭桌创投、凡卓资本三个板块，其中凡卓资本累计帮助近600家企业完成超800亿元融资，近两年内帮助数百个明星项目完成近300亿元融资。</p>
            </div>
          </div>
        </template>
        <div class="intro-profile">
          <div class="pro-item-list swiper-container profileSwiper">
            <div class="pro-item swiper-wrapper">
              <div class="swiper-slide pro-swiper-item" v-for="item in profileData">
                <div class="title">{{ item.title }}</div>
                <div class="line"></div>
                <div class="name">{{ item.source }}</div>
              </div>
            </div>
          </div>


          <div class="profile-arrow-line">
            <div class="aa-left" @click="onClickLeftSwiper()"></div>
            <div class="aa-right" @click="onClickRightSwiper()"></div>
          </div>

        </div>
      </div>

      <div class="fzg-teams-g4">
        <img class="team-person" src="../../assets/img2/mobile/about/team.jpg" alt="">
        <div class="team-data">
          <div class="person-item" @click="showPartner(0)"></div>
          <div class="person-item" @click="showPartner(1)"></div>
          <div class="person-item" @click="showPartner(2)"></div>
          <div class="person-item" @click="showPartner(3)"></div>
        </div>
      </div>

      <div  class="fzg-advantage">
        <img class="adv-img" src="../../assets/img2/mobile/about/advantage.jpg" alt="">
      </div>

      <div class="section fzg-history">
        <!-- <img class="his-img" src="../../assets/img2/mobile/about/growth.png"> -->
        <!-- <img class="his-img" src="https://static-image.xfz.cn/1697974329548/about_jn_m.jpg"> -->
        <img class="his-img" src="https://static-image.xfz.cn/1698580607763/about_us_mobile.jpg">
      </div>


      <transition name="fade">
        <fzg-about-partner-modal
          v-if="isShowPartnerModal"
          :partner-index="partnerIndex"
          @hide-modal="isShowPartnerModal = false"/>
      </transition>

    </div>
</template>

<script>

import util from '../../assets/js/util'
import FzgAboutPartnerModal from './FzgAboutPartnerModalMobile.vue'
import FzgMenu from '../common/FzgMenuMobile.vue'

export default{
    components:{
      FzgMenu,
      FzgAboutPartnerModal,
    },
    props:[''],
    data(){
        return{
          isShowPartnerModal: false,
          partnerIndex: 0,
          profileSwiper: '',
          profileData: [
            {
              title: "2022年度中国新能源领域财务顾问 TOP 1",
              source: "企名片"
            },
            {
              title: "2022年度中国企业服务领域财务顾问 TOP 2",
              source: "企名片"
            },
            {
              title: "2022年度中国最佳财务顾问综合榜 TOP 4",
              source: "企名片"
            },
            {
              title: "2022中国最具影响力新型投行 TOP 5",
              source: "36氪"
            },
            {
              title: "2022硬科技 FA 榜",
              source: "科创板日报"
            },
            {
              title: "2022年度FA先锋TOP 5",
              source: "钛媒体"
            },
            {
              title: "2022中国一级市场FA活跃度TOP 5",
              source: "IT桔子"
            },
            {
              title: "2022年度中国医疗健康财务顾问交易量卓越榜",
              source: "IT桔子"
            },
            {
              title: "2022最佳FA机构",
              source: "母基金研究中心"
            },
            {
              title: "2022硬科技精品投行",
              source: "亿欧"
            },
            {
              title: "WISE2022新经济之王-最具影响力新型投行TOP 5",
              source: "36氪"
            },
            {
              title: "2021年河南洪涝灾害救援扶贫基金捐赠",
              source: "中国扶贫基金会"
            },
            {
              title: "WISE2021新经济之王-最具影响力新型投行TOP 10",
              source: "36氪"
            },
            {
              title: "2021财务顾问机构-综合财务顾问机构榜TOP 30",
              source: "企名片"
            },
            {
              title: "WISE2020中国最具影响力新型投行TOP 10",
              source: "36氪"
            },
            {
              title: "WISE2020中国最具成长力早期投资机构TOP 10",
              source: "36氪"
            },
            {
              title: "2019年度中国最佳FA机构TOP 10",
              source: "企名片"
            },
            {
              title: "2019未来医疗100强榜-年度FA机构TOP 5",
              source: "动脉网"
            },
            {
              title: "2019年中国企业服务领域财务顾问机构10强-TOP 1",
              source: "企名片"
            },
            {
              title: "WISE2019-中国最具影响力新型投行TOP 10",
              source: "36氪"
            }
          ]

        }
    },
    methods:{
      initActivitySwiper() {
        var self = this
        $(function() {
          self.profileSwiper = new Swiper(".profileSwiper", {
            slidesPerView: 2,
            centeredSlides: false,
            loop: true,
            loopFillGroupWithBlank: true,
            spaceBetween: 15,
            slidesPerGroup: 2,
            autoplay: {
              delay: 5000,
            },
          });
        })
      },

      onClickRightSwiper(){
        this.profileSwiper.slideNext(200, '')
      },
      onClickLeftSwiper(){
        this.profileSwiper.slidePrev(200, '')
      },
      showPartner(index) {
        this.isShowPartnerModal = true
        this.partnerIndex = index
      }
    },
    mounted(){
      this.initActivitySwiper()
    },
    watch: {
      'fzTeamList': function() {
      },
    },

}
</script>

<style lang="scss">
.fzg-about-mobile{
  .fzg-banner {
    // border: 1px solid red;
    // background-size: 100% auto;
    // position: relative;
    .banner-bg {
      width: 100%;
      height: auto;
      // border: 1px solid green;
    }
    .banner-intro{
      width: 100%;
      height: auto;
      // border: 1px solid green;
    }
  }

  .fzg-about-intro {
    // border: 1px solid red;
    // height: 950px;
    margin: 0 auto;
    position: relative;
    .eco-title {
      width: 190px;
      position: absolute;
      left: 50%;
      right: 0;
      top: 75px;
      margin-left: -95px;
      // border: 1px solid #ce262f;
    }
    .intro-title-line {
      position: absolute;
      left: 50%;
      right: 0;
      top: 190px;
      width: 80px;
      height: 4px;
      margin-left: -40px;
      background-color: #ce262f;
    }
    .intro-content {
      // border: 1px solid black;
      width: 1100px;
      position: absolute;
      left: 50%;
      right: 0;
      top: 220px;
      margin-left: -550px;
      .left {
        // border: 1px solid #ce262f;
        display: inline-block;
        vertical-align: top;
        width: 400px;
        height: 200px;
        margin-top: 70px;
        .logo {
          width: 100%;
        }
      }
      .right {
        // border: 1px solid green;
        display: inline-block;
        width: 690px;
        height: 300px;
        text-align: justify;
        padding: 20px 10px;
        p {
          // font-family: SourceHanSansCN-Medium;
          font-size: 19px;
          line-height: 1.6;
          color: #221c0e;
        }
      }
    }
    .intro-profile {
      // border: 1px solid red;
      // width: 93%;
      margin: 0 auto;
      text-align: center;
      .pro-item-list {
        width: 85%;
        // border: 1px solid red;
        .pro-item {
          border: 1px solid green;
          // width: 250px;
          // height: 220px;
          padding: 10px 0px;
          // background: #ececec;
          .pro-swiper-item {
            // border: 1px solid #ccc;
            background: #ececec;
            // width: 180px;
            height: 140px;
            text-align: left;
            padding: 15px;
            .title {
              font-size: 14px;
              line-height: 1.2;
              // border: 1px solid red;
              min-height: 55px;
              margin-top: 15px;
              text-align: justify;
            }
            .line {
              width: 40px;
              border-top: 3px solid #be1717;
              margin: 10px 0 8px;
            }
            .name {
              font-size: 13px;
            }
          }
        }
      }
      .profile-arrow-line {
        // border: 1px solid red;
        width: 100%;
        text-align: center;
        margin-top: 10px;
        .aa-left {
          // border: 1px solid red;
          width: 28px;
          height: 28px;
          background: url(../../assets/img2/pc/about/ab-arrow-left.png) no-repeat;
          background-size: 100%;
          // transform: rotate(180deg);
          cursor: pointer;
          display: inline-block;
        }
        .aa-right {
          // border: 1px solid red;
          width: 28px;
          height: 28px;
          background: url(../../assets/img2/pc/about/ab-arrow-right.png) no-repeat;
          background-size: 100%;
          cursor: pointer;
          display: inline-block;
        }
      }
    }
  }

  .fzg-teams-g4 {
    overflow: auto;
    // border: 1px solid red;
    position: relative;
    .team-person {
      width: 100%;
      height: auto;
    }
    .team-data {
      // border: 1px solid #ce262f;
      background-size: contain;
      background-repeat: no-repeat;
      width: 100%;
      position: absolute;
      left: 0;
      top: 80px;
      right: 0;
      bottom: 0;
      .person-item {
        // border: 1px solid red;
        width: 49%;
        height: 49%;
        display: inline-block;
        cursor: pointer;
      }
    }
  }
  .fzg-advantage {
    // border: 1px solid green;
    position: relative;
    .adv-img {
      width: 100%;
      height: auto;
    }
  }
  .fzg-history {
    // border: 1px solid red;
    margin: 0 auto;
    position: relative;
    .his-img {
      width: 100%;
      height: auto;
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s ease;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

}
</style>



// WEBPACK FOOTER //
// FzgAboutMobile.vue?7bccb046